import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterSelect',
    standalone: false
})
export class MatSelectExtendPipe implements PipeTransform {
  transform(list: Array<any>, filterValue: string): Array<any> {
    return list.filter((x: any) =>
      ( x.longDescription.toUpperCase()).includes(
        filterValue.toUpperCase()
      )
    );
  }
}
